import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ISectiuneAddPayload, ISectiuneUpdatePayload } from './sectiuni-proiecte.interface';

@Injectable({
    providedIn: 'root'
})
export class SectiuniProiecteService {
    // private token!: string;
    // private httpOptions: any;

    private basePath = environment.interop.basePath;
    private listSectiuniURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteSectiuni.list;
    private listDTSectiuniURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteSectiuni.listDT;
    private addSectiuneURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteSectiuni.store;
    private updateSectiuneURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteSectiuni.update;
    private deleteSectiuneURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteSectiuni.delete;

    constructor(private http: HttpClient) { }

    listSectiuni() {
        return this.http.get(this.listSectiuniURL);
    }

    listDTSectiuni() {
        return this.http.post(this.listDTSectiuniURL, {});
    }

    addSectiune(data: ISectiuneAddPayload) {
        return this.http.post(this.addSectiuneURL, data);
    }

    updateSectiune(data: ISectiuneUpdatePayload) {
        return this.http.put(this.updateSectiuneURL, data);
    }

    deleteSectiune(id: number) {
        return this.http.delete(this.deleteSectiuneURL + id);
    }

    // setToken(token: string) {
    //     this.token = token;
    //     this.httpOptions = {
    //         headers: new HttpHeaders({
    //             'Content-Type': 'application/json',
    //             Accept: 'application/json',
    //             Authorization: `Bearer ${this.token}`,
    //         }),
    //     };
    // }
}
